import { render, staticRenderFns } from "./Galleries.vue?vue&type=template&id=15c45fa9&scoped=true&"
import script from "./Galleries.vue?vue&type=script&lang=js&"
export * from "./Galleries.vue?vue&type=script&lang=js&"
import style0 from "./Galleries.vue?vue&type=style&index=0&id=15c45fa9&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c45fa9",
  null
  
)

export default component.exports